import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is carried by httpOnly cookie (secure=true, samesite=none). No token in localStorage.
const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default client;
